import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './lib/auth'
import ErrorBoundary from './components/ErrorBoundary'
import SessionBar from './components/SessionBar'
import './index.css'

// The root AuthProvider that src/lib/auth.tsx always anticipated ("spz-00 is
// expected to wrap the app root in main.tsx"). It is nest-safe, so the pages that
// currently self-wrap keep working unchanged and simply stop opening a second
// auth subscription.
//
// SessionBar sits above the router so every screen gets sign-out without opting
// in. It renders nothing when signed out.
//
// The boundary wraps only the router, not SessionBar: if a page crashes you keep
// the menu and can navigate away instead of being stranded.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <SessionBar />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </StrictMode>,
)
